module.exports = __webpack_public_path__ + "img/beer_id-32.a2045867.png";